import { getJson } from '../fetch';
import API_BASE_PATH from './basePath';

export const getDegreePrograms = () => getJson(`${API_BASE_PATH}/degree-programs`);

export const getSavedDegreePrograms = (type) => getJson(`${API_BASE_PATH}/degree-programs/saved-degree-programs${type ? `?type=${type}` : ''}`);
